import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import ProblemSection from './components/ProblemSection';
import DefinitionSection from './components/DefinitionSection';
import ValuesSection from './components/ValuesSection';
import ScopeSection from './components/ScopeSection';
// import CasesSection from './components/CasesSection'; // 元のセクション（いつでも戻せます）
import CasesSection from './components/CasesSectionComingSoon';
import ClientsSection from './components/ClientsSection';
import StanceSection from './components/StanceSection';
import ContactSection from './components/ContactSection';
import { useSEO } from '@/hooks/useSEO';

export default function Home() {
  useSEO({
    title: 'メセナインターコム株式会社 | 医療・福祉・教育・地域・文化の意味設計と価値創造',
    description: 'mecena Intercomは、医療・福祉・教育・地域・文化の領域で、組織の意味設計・価値創造・市場創造を行うコンサルティングファームです。渋谷区南平台を拠点に、専門性を社会に届ける構造を設計します。',
    keywords: '意味設計,価値創造,市場創造,医療,福祉,教育,地域,文化,コンサルティング,渋谷,メセナインターコム',
    ogUrl: 'https://mecena-intercom.co.jp/',
    canonical: 'https://mecena-intercom.co.jp/',
  });

  return (
    <div className="bg-warm-white min-h-screen">
      <Navbar />
      <main>
        <HeroSection />
        <ProblemSection />
        <DefinitionSection />
        <ValuesSection />
        <ScopeSection />
        <CasesSection />
        <ClientsSection />
        <StanceSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}
